export default {
  props: {
    label: String,
    disabled: Boolean,
    form: String,
    validationsError: String,
    desc: String,
    small: String,
    value: [String, Number],
    showValidationError: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    disablePaste: {
      type: Boolean,
      default: false
    },
    inputAttr: {
      type: Object,
      required: true
    },
  },
  template: `
    <div class="field">
        <div class="form-item">
          <label v-if="label"  :for="inputAttr.id">{{label}}</label>
          <input
            class="form-text"
            v-bind="inputAttr"
            v-model="currentValue"
            :type="(type && !showPassword) ? type : 'text'"
            @change="changeInput"
            @input="update">
          <a
          v-if="type === 'password'"
          href="#"
          tabindex="-1"
          class="toggle-password"
          aria-label="Toggle password display"
          :class="{'active': !showPassword}"
          @click="toggleInputType">
            <svg width="20" class="icon-eye" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.6" d="M19.8675 7.40644C17.6931 2.81212 14.4062 0.5 9.99999 0.5C5.59148 0.5 2.30689 2.81212 0.132451 7.40874C0.0452335 7.59398 0 7.79629 0 8.00115C0 8.20601 0.0452335 8.40832 0.132451 8.59356C2.30689 13.1879 5.59378 15.5 9.99999 15.5C14.4085 15.5 17.6931 13.1879 19.8675 8.59126C20.0442 8.21856 20.0442 7.78604 19.8675 7.40644ZM9.99999 13.8436C6.30024 13.8436 3.59137 11.9617 1.68071 8C3.59137 4.03834 6.30024 2.15644 9.99999 2.15644C13.6997 2.15644 16.4086 4.03834 18.3193 8C16.4109 11.9617 13.702 13.8436 9.99999 13.8436ZM9.90825 3.95092C7.67876 3.95092 5.87132 5.7638 5.87132 8C5.87132 10.2362 7.67876 12.0491 9.90825 12.0491C12.1377 12.0491 13.9452 10.2362 13.9452 8C13.9452 5.7638 12.1377 3.95092 9.90825 3.95092ZM9.90825 10.5767C8.48844 10.5767 7.33929 9.42408 7.33929 8C7.33929 6.57592 8.48844 5.42331 9.90825 5.42331C11.3281 5.42331 12.4772 6.57592 12.4772 8C12.4772 9.42408 11.3281 10.5767 9.90825 10.5767Z" fill="#050505"/>
            </svg>
          </a>
          <small v-if="small">{{small}}</small>
          <div v-if="showValidationError" class="validation-info">
            <!--:id="inputAttr['aria-describedby']"-->
            <div v-if="serverError" class="error-server">
              {{serverError}}
            </div>
          </div>
      </div>
    </div>`,
  mounted() {
    this.currentValue = this.value;
    this.serverError = this.validationsError;
    this.updateFormInputs();

  },
  data() {
    return {
      currentValue: '',
      serverError: '',
      showPassword: false,
    };
  },
  methods: {
    updateFormInputs() {
      let curForm = $(this.$parent.$refs[this.form]);
    },
    changeInput() {
      if (this.type === 'tel')
        this.changeNumber();
      this.$emit('change');
    },

    update(event) {
      if (this.type === 'tel')
        this.changeNumber();
      const regexp = this.inputAttr.pattern ? new RegExp(this.inputAttr.pattern) : null;

      if (regexp) {
        if (this.currentValue.match(regexp)) {
          this.$emit('input', this.currentValue);
        } else {
          return false;
        }
      }
      this.$emit('input', this.currentValue);
    },
    toggleInputType(event) {
      event.preventDefault();
      this.showPassword = !this.showPassword;
    },
    submit() {
      let curForm = $(this.$parent.$refs[this.form]);
      if (!this.currentValue) {
        this.serverError = 'This field is required.';
        return;
      }
      if (this.form) {
        if (curForm.valid()) {
          this.$emit('submit', this.currentValue);
        }
      } else {
        this.$emit('submit', this.currentValue);
      }
    }
  }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/ui/ui-input.js